export default __webpack_public_path__ + "static/media/recon.d68f8b52.jpg";